module.exports = __webpack_public_path__ + "static/img/37-1.b569036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/37-1.jpg
// module id = zabx
// module chunks = 0